import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ZeitArtsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ZeitArtsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ZeitArtsServiceModule {}
